import { render, staticRenderFns } from "./DepartmentsCard.vue?vue&type=template&id=19f17ef8&scoped=true"
import script from "./DepartmentsCard.vue?vue&type=script&lang=js"
export * from "./DepartmentsCard.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsCard.vue?vue&type=style&index=0&id=19f17ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f17ef8",
  null
  
)

export default component.exports